export const BIZ_GUBUN_SEPARATOR = ','

export function isExcludedBizGubun(value: string): boolean {
  return String(value || '').includes('치매')
}

export function filterBizGubunValues(values: string[] | null | undefined): string[] {
  return parseBizGubun(values).filter((item) => !isExcludedBizGubun(item))
}

export function filterBizGubunOptions<T extends { value: string; label?: string }>(options: T[]): T[] {
  return options.filter(
    (item) => !isExcludedBizGubun(item.value) && !isExcludedBizGubun(item.label || ''),
  )
}

export function parseBizGubun(value: string | string[] | null | undefined): string[] {
  let items: string[]

  if (Array.isArray(value)) {
    items = value.map((item) => String(item || '').trim()).filter(Boolean)
  } else {
    items = String(value || '')
      .split(BIZ_GUBUN_SEPARATOR)
      .map((item) => item.trim())
      .filter(Boolean)
  }

  return [...new Set(items.filter((item) => !isExcludedBizGubun(item)))]
}

export function serializeBizGubun(values: string[] | null | undefined): string {
  return parseBizGubun(values ?? []).join(BIZ_GUBUN_SEPARATOR)
}

export function hasBizGubunSelection(values: string | string[] | null | undefined): boolean {
  return parseBizGubun(values).length > 0
}
